'use client';

import type { CSSProperties, ReactNode } from 'react';
import { forwardRef } from 'react';
import { cx } from '../../utils/cx';
import type { SpacingTypographyProps } from './utils/spacingTypographyHelper';
import type { TypographyProps } from './utils/typographyHelper';
import { typographyStyle } from './utils/typographyHelper';
import styles from './typography.module.css';

export interface BaseProps extends TypographyProps, SpacingTypographyProps {
  children?: ReactNode;
  className?: string;
}

export const Base = forwardRef<HTMLElement, BaseProps>((props, ref) => {
  const { children, className } = props;
  const style: CSSProperties = {
    color: 'var(--color-foreground)',
    ...typographyStyle({}, props),
  };
  return (
    <span
      ref={ref as React.Ref<HTMLSpanElement>}
      className={cx(styles.text, className)}
      style={style}
    >
      {children}
    </span>
  );
});

Base.displayName = 'Base';
